import controller from './item.controller';
import template from './item.html';

const menuItemComponent = {
  restrict: 'E',
  bindings: {
    menu: '=',
    settings: '=',
    activeMenu: '='
  },
  controller,
  template
};

export default menuItemComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/main/item/item.component.js
 **/